import { render } from "./behaviorSignature.vue?vue&type=template&id=c577250a&scoped=true"
import script from "./behaviorSignature.vue?vue&type=script&lang=js"
export * from "./behaviorSignature.vue?vue&type=script&lang=js"

import "./behaviorSignature.vue?vue&type=style&index=0&id=c577250a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c577250a"]])

export default __exports__